import { get } from './api-service';

const routes = {
  base: 'roles',
};

export const getRoles = async () => {
  return await get(`${routes.base}`);
}
